import { Typography } from '@mui/material';
import { BaseActivityItem } from '../BaseActivityItem';
import { CommentOutlined } from '@mui/icons-material';
import { BaseNoteActivityItemProps } from './BaseNote.component';
import { Button } from '../../Button';
import { Link } from 'react-router-dom';
import { notesRoute, providerPatientRoute } from '@uplift/constants';
import { MedicalNoteType } from '@uplift/api';

export const CommunicationNoteActivityItem: React.FC<BaseNoteActivityItemProps> = props => {
  const params = providerPatientRoute.useParams();

  if (props.note.status === 'incomplete') {
    const button = (
      <Button
        variant="outlined"
        color="secondary"
        component={Link}
        to={notesRoute.createLink({
          noteType: MedicalNoteType.communicationNote,
          noteId: props.note.id,
          patientId: params.patientId
        })}
      >
        Complete Note
      </Button>
    );

    return (
      <BaseActivityItem
        title={<Typography>Communication Note</Typography>}
        icon={CommentOutlined}
        color="lightBlue"
        rightContent={button}
        highlighted
      />
    );
  }

  const reason = props.note.form['contactReason'];

  return (
    <BaseActivityItem
      onClick={props.onClick}
      title={<Typography>Communication Note</Typography>}
      icon={CommentOutlined}
      color="lightBlue"
      rightContent={(
        <Typography variant="body2" color="textPrimary">
          with {props.provider.firstName[0]}. {props.provider.lastName}
        </Typography>
      )}
    >
      <Typography color="textSecondary">
        <b>{reason.label}</b>: {reason.value}
      </Typography>
    </BaseActivityItem>
  );
};
